export default __webpack_public_path__ + "static/media/hank.4238a2f9.png";